import React from 'react';
import { env } from 'utils/env';
import { Grid, Box } from '@mui/material';
import { Card, Typography } from '@totalsoft/rocket-ui';
import SettingsApplications from '@mui/icons-material/SettingsApplications';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'hooks/apollo';
import { API_VERSION_QUERY, DATABASE_VERSION_QUERY, GQL_VERSION_QUERY } from '../queries';
import WrappedLinearProgress from 'components/common/WrappedLinearProgress';

const SettingsContainer = () => {
  const { t } = useTranslation();

  const { loading: apiVersionLoading, data: apiVersionData } = useQuery(API_VERSION_QUERY, {
    fetchPolicy: 'network-only'
  });
  const apiVersion = apiVersionData && apiVersionData.apiVersion;

  const { loading: databaseVersionLoading, data: databaseVersionData } = useQuery(DATABASE_VERSION_QUERY, {
    fetchPolicy: 'network-only'
  });
  const databaseVersion = databaseVersionData && databaseVersionData.databaseVersion;

  const { loading: gqlVersionLoading, data: gqlVersion } = useQuery(GQL_VERSION_QUERY);
  const gqlVersionData = gqlVersion && gqlVersion.gqlVersion;

  return (
    <Grid>
      <Card icon={SettingsApplications} iconColor='primary' title={t('Settings.Title')}>
        <Grid container spacing={1}>
          <Grid item container gap={0.5}>
            <Typography fontSize='1rem' fontWeight='bold'>
              {t('Settings.UIVersionLabel')}:
            </Typography>
            <Typography fontSize='1rem'>
              {t('Settings.SettingsVersionValue', {
                data: {
                  version: env.REACT_APP_VERSION,
                  date: t('LONG_DATE', { date: env.REACT_APP_DATE })
                }
              })}
            </Typography>
          </Grid>

          {apiVersionLoading ? (
            <Grid item container gap={1} alignItems='center'>
              <Typography fontSize='1rem' fontWeight='bold'>
                {t('Settings.APIVersionLabel')}:
              </Typography>
              <Box flexGrow={1}>
                <WrappedLinearProgress color='primary' />
              </Box>
            </Grid>
          ) : (
            <Grid item container gap={0.5}>
              <Typography fontSize='1rem' fontWeight='bold'>
                {t('Settings.APIVersionLabel')}:
              </Typography>
              <Typography fontSize='1rem'>
                {t('Settings.SettingsVersionValue', {
                  data: {
                    version: apiVersion?.version,
                    date: t('LONG_DATE', { date: apiVersion?.date })
                  }
                })}
              </Typography>
            </Grid>
          )}

          {gqlVersionLoading ? (
            <Grid item container gap={1} alignItems='center'>
              <Typography fontSize='1rem' fontWeight='bold'>
                {t('Settings.GQLVersionLabel')}:
              </Typography>
              <Box flexGrow={1}>
                <WrappedLinearProgress color='primary' />
              </Box>
            </Grid>
          ) : (
            <Grid item container gap={0.5}>
              <Typography fontSize='1rem' fontWeight='bold'>
                {t('Settings.GQLVersionLabel')}:
              </Typography>
              <Typography fontSize='1rem'>
                {t('Settings.SettingsVersionValue', {
                  data: {
                    version: gqlVersionData?.version,
                    date: t('LONG_DATE', { date: gqlVersionData?.date })
                  }
                })}
              </Typography>
            </Grid>
          )}

          {databaseVersionLoading ? (
            <Grid item container gap={1} alignItems='center'>
              <Typography fontSize='1rem' fontWeight='bold'>
                {t('Settings.DatabaseVersionLabel')}{' '}
              </Typography>
              <Box flexGrow={1}>
                <WrappedLinearProgress color='primary' />
              </Box>
            </Grid>
          ) : (
            <Grid item container gap={0.5}>
              <Typography fontSize='1rem' fontWeight='bold'>
                {t('Settings.DatabaseVersionLabel')}:
              </Typography>
              <Typography fontSize='1rem'>{databaseVersion}</Typography>
            </Grid>
          )}
        </Grid>
      </Card>
    </Grid>
  );
};

export default SettingsContainer;
